export default {
    nl: {
        intro: {
            subtitle: 'Visual design',
            title: 'Een sterk merk bouwen.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/visual-design/hero.jpg',
        },
        type: 'Visual design',
        title: 'Maak indruk met onze experts in visual design en branding',
        description:
            'Transformeer je merk met onze innovatieve visual design en krachtige branding strategieën! Voor een blijvende indruk.',
        content: [
            {
                type: 'text',
                title: 'Visual design/branding',
                content:
                    'Visual design is meer dan alleen maar mooie plaatjes laten zien. Je wilt immers een blijvende indruk achterlaten. Visual design en branding spelen een belangrijke rol bij het creëren van een sterk merkimago en het effectief communiceren van je boodschap. Het gaat niet enkel om het belang van het product, maar ook om het creëren van een optimale gebruikerservaring door middel van slimme en doelgerichte ontwerpen.',
            },
            {
                type: 'images',
                images: ['https://23g-website.s3.eu-central-1.amazonaws.com/services/sites.webp'],
            },
            {
                type: 'text',
                title: 'Wie zijn onze designers',
                content:
                    'Ons designteam bestaat uit ware Michelangelo’s die met hun technische expertise en creatief brein jouw merk tot leven kunnen brengen. Wij geloven in co-creatie en werken daarom graag nauw samen met onze klanten. Met behulp van creatieve technieken brengen we jouw visie in kaart en pluizen we tot op de bodem uit wat er nodig is om jouw doelgroep op de meest effectieve wijze aan te spreken. Of het nu gaat om het ontwikkelen van een aantrekkelijke, intuïtieve gebruikersinterface (<a href="/diensten/ui-ux-design/">UI/UX-design</a>), het creëren van <a href="/diensten/native-apps/">native apps</a>, webapplicaties, <a href="/diensten/design-system/">design systems</a> of het vormgeven van een consistente brand identity met logo design en typografie – niets is ons te gek!',
            },
            {
                type: 'quote',
                content: 'VISUAL DESIGN IS MEER DAN ALLEEN MAAR MOOIE PLAATJES LATEN ZIEN.',
            },
            {
                type: 'text',
                title: 'Wij helpen je met digitaal ontwerpen',
                content: `
                    23G ontzorgt door elk ontwerp te optimaliseren voor verschillende apparaten en platforms. Zo zorgen we ervoor dat je boodschap consistent en effectief wordt overgebracht via een design system, ongeacht hoe je gebruikers met je merk in contact komen.
                    <br><br>
                    We hanteren duidelijke brand guidelines en integreren graphic elements om visuele communicatie en visual hierarchy te versterken, waardoor we een uniform en herkenbaar beeld scheppen in al onze digitale producten.
                    <br><br>
                    Ook op het gebied van <a href="/diensten/api/">API’s</a> en <a href="/diensten/strategy-session/">strategiesessies</a> helpen we je graag!
                    `,
            },
            {
                type: 'case',
                case: 'bobbys',
            },
        ],
        related_services: ['design-system', 'strategy-session', 'api'],
        contact: {
            title: '',
            employee: 'michiel',
        },
    },
    en: {},
};
